import { BasicTextField } from '../BasicTextField/BasicTextField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const CountyField: React.FC<FormFieldWrapper> = (props) => (
  <BasicTextField {...props} field="county" labelKey="fields.county.label" />
)
